import { render } from "./IconPlus.vue?vue&type=template&id=620ab0fd"
const script = {}

import exportComponent from "/home/balluff-sales-applinksderisario/sales-app.balluff.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__